export default "__VITE_ASSET__7d2ab72b__"